import { History, Sparkles } from "lucide-react";
import { COST_TYPE_INFO } from "./SplitPopover";

// Roadmap 3.3 — sugerencia de reparto de gasto en el popover de asignación.
// Componente AISLADO a propósito (mismo patrón que ClassifySuggestion, 3.4):
// solo pinta una línea compacta con la sugerencia (histórico del proveedor o
// IA con consentimiento) y un botón «Aplicar» que RELLENA el editor de líneas.
// Aplicar NO guarda nada: la confirmación humana sigue siendo el botón
// Guardar existente del editor. Sin sugerencia, aquí no se pinta nada.

export default function SplitSuggestion({ suggestion, clients, services, onApply, matches = false }) {
  if (!suggestion?.lines?.length) return null;

  const isAi = suggestion.source === "ai";
  const total = suggestion.lines.reduce((acc, l) => acc + (l.amount_eur ?? 0), 0);

  const lineLabel = (l) => {
    if (l.cost_type === "client_direct") {
      const cliName = clients.find((c) => c.client_id === l.client_id)?.name || "Cliente";
      const svcName = services.find((s) => s.service_id === l.service_id)?.service_name;
      return svcName ? `${cliName} · ${svcName}` : cliName;
    }
    return COST_TYPE_INFO[l.cost_type]?.label || l.cost_type;
  };

  const summary = suggestion.lines
    .map((l) => {
      const pct = total !== 0 ? Math.round(((l.amount_eur ?? 0) / total) * 100) : 0;
      return `${lineLabel(l)} ${pct}%`;
    })
    .join(" · ");

  return (
    <div
      className={`flex items-center gap-1.5 text-xs rounded border px-2 py-1.5 min-w-0 ${
        isAi
          ? "text-violet-800 bg-violet-50 border-violet-200"
          : "text-amber-800 bg-amber-50 border-amber-200"
      }`}
      data-testid="split-suggestion"
    >
      {isAi ? (
        <Sparkles className="w-3.5 h-3.5 shrink-0" />
      ) : (
        <History className="w-3.5 h-3.5 shrink-0" />
      )}
      <span className="font-medium shrink-0">
        {matches
          ? (isAi ? "Coincide con la sugerencia IA:" : "Coincide con tu histórico:")
          : (isAi ? "Sugerencia IA:" : "Sugerencia (histórico):")}
      </span>
      <span className="flex-1 min-w-0 truncate" title={suggestion.reason}>
        {summary}
        {isAi && suggestion.confidence != null
          ? ` (confianza ${Math.round(suggestion.confidence * 100)}%)`
          : ""}
        {suggestion.reason ? ` — ${suggestion.reason}` : ""}
      </span>
      {matches ? (
        <span className="ml-auto shrink-0 font-medium" aria-label="La sugerencia coincide con las líneas actuales">
          ✓
        </span>
      ) : (
      <button
        type="button"
        onClick={onApply}
        className={`ml-auto shrink-0 rounded border px-1.5 py-0.5 font-medium ${
          isAi
            ? "border-violet-300 hover:bg-violet-100"
            : "border-amber-300 hover:bg-amber-100"
        }`}
        data-testid="split-suggestion-apply"
      >
        Aplicar
      </button>
      )}
    </div>
  );
}
